import * as React from "react";
import { cn } from "@/lib/utils";
import { statusToneClass, toneForStatus } from "./statusTones";

export type ChipStatus =
  | "pending"
  | "confirmed"
  | "active"
  | "completed"
  | "cancelled"
  | "expired"
  | "verified";

// Every chip resolves through the shared map, so a status is the same colour
// here as on StatusBadge and Badge.
const chipMap = Object.fromEntries(
  (["pending", "confirmed", "active", "completed", "cancelled", "expired", "verified"] as const)
    .map((status) => [status, statusToneClass[toneForStatus(status)]]),
) as Record<ChipStatus, string>;

export interface StatusChipProps {
  status: ChipStatus;
  children?: React.ReactNode;
  className?: string;
}

export function StatusChip({ status, children, className }: StatusChipProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center h-6 px-2.5 rounded-full text-xs font-medium border",
        chipMap[status],
        className
      )}
    >
      {children ?? status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}
